import { render, staticRenderFns } from "./baseCard.vue?vue&type=template&id=8fd45f4c&scoped=true"
import script from "./baseCard.vue?vue&type=script&lang=js"
export * from "./baseCard.vue?vue&type=script&lang=js"
import style0 from "./baseCard.vue?vue&type=style&index=0&id=8fd45f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd45f4c",
  null
  
)

export default component.exports